// extracted by mini-css-extract-plugin
module.exports = {"button":"formRestorePassword_button__hi_la","wrapper_field":"formRestorePassword_wrapper_field__VkHNi","form":"formRestorePassword_form__jHkhv"};